// extracted by mini-css-extract-plugin
export var filterIncDec = "_4x-0";
export var leftBorder = "_4x-1";
export var rightBorder = "_4x-2";
export var stringInput = "_4x-3";